import { combineReducers } from 'redux';

import auth from './authentication';
import customer from './customer';
import customizeprintings from './customizeprintings';
import country from './country';
import state from './state';
import city from './city';
import account from './account';
import item from './item';
import companyGroup from './companyGroup';
import company from './company';
import warehouse from './warehouse';
import category from './category';
import brand from './brand';
import color from './color';
import driver from './driver';
import series from './series';
import itemGroup from './itemGroup';
import model from './model';
import style from './style';
import size from './size';
import vehicle from './vehicle';
import transport from './transport';
import hsn from './hsn';
import hsnSub from './hsnSub';
import vendor from './vendor';
import daybook from './daybook';
import unit from './unit';
import user from './user';
import bank from './bank';
import glGroup from './glGroup';
import sales from './salesInvoice';
import billTerm from './billTerm';
import salesLineItem from './salesLineItem';
import purchaseInvoice from './purchaseInvoice';
import salesReturnInvoice from './salesReturnInvoice';
import purchaseReturnInvoice from './purchaseReturnInvoice';
import uqc from './uqc';
import salesRepresentative from './salesRepresentative';
import taxGroup from './taxGroup';
import mainAndSubHsn from './mainAndSubHsn';
import voucher from './voucher';
import salesLineDetail from './salesLineDetail';
import purchaseLineDetail from './purchaseLineDetail';
import salesReturnLineDetail from './salesReturnLineDetail';
import purchaseReturnLineDetail from './purchaseReturnLineDetail';
import stocktransfer from './stocktransfer';
import reports from './reports';
import users from './user';
import area from './area';
import globalImei from './globalImei';
import dashboard from './dashboard';
import issueInventory from './issueinventory';
import issueLineItem from './issueLineItem';
import receiveInventory from './receiveInventory';
import receiveLineItem from './receiveLineitem';
import setupPrint from './setupPrint';
import settings from './settings';
import journalVoucher from './JournalVoucher';
import issue from './issue';
import globalSearch from './globalSearch';
import utility from './utility';
import logs from './logs';
import CheckOs from './CheckOs';
import Package from './package';
import NotifyMe from './notifyMe';
import salesChallan from './salesChallan';
import purchaseChallan from './PurchaseChallan'

const appReducer = combineReducers({
   auth,
   customer,
   customizeprintings,
   setupPrint,
   journalVoucher,
   country,
   state,
   city,
   account,
   item,
   companyGroup,
   company,
   warehouse,
   category,
   brand,
   color,
   driver,
   series,
   itemGroup,
   model,
   style,
   size,
   vehicle,
   transport,
   hsn,
   hsnSub,
   vendor,
   daybook,
   unit,
   bank,
   glGroup,
   sales,
   salesChallan,
   billTerm,
   salesLineItem,
   purchaseInvoice,
   salesReturnInvoice,
   purchaseReturnInvoice,
   salesRepresentative,
   user,
   uqc,
   taxGroup,
   mainAndSubHsn,
   voucher,
   salesLineDetail,
   purchaseLineDetail,
   salesReturnLineDetail,
   purchaseReturnLineDetail,
   stocktransfer,
   reports,
   users,
   area,
   globalImei,
   dashboard,
   issueInventory,
   issueLineItem,
   receiveInventory,
   receiveLineItem,
   issue,
   globalSearch,
   utility,
   logs,
   CheckOs,
   settings,
   Package,
   NotifyMe,
   purchaseChallan
   // alert,
});

const rootReducer = (state, action) => {
   if (action.type === 'AUTH_LOGOUT') {
      return appReducer(undefined, action);
   }
   return appReducer(state, action);
};

export default rootReducer;
